import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { userModel } from "../../api/models/userModel";
import { User } from "../../ts/Auth";
import {
  TChangePasswordBody,
  TEditUserInfoBody
} from "../../types/server-api/user";

export enum UserActions {
  SET_USER = "SET_USER",
  SET_PROFILE_IMAGE = "SET_PROFILE_IMAGE",
}

type TSetUserAction = {
  type: UserActions.SET_USER;
  payload: User | null;
};

type TDecodedUser = {
  exp: number;
  iat: number;
  user: User | null;
};

export type TUserAction = TSetUserAction;

const SET_USER_FROM_TOKEN = (token: string) => {
  Cookies.set("_token", token, {
    expires: 28,
    // sameSite: "strict",
    // secure: true,
  });
  const decoded: TDecodedUser = jwtDecode(token);

  return decoded;
};

export const GET_USER_FROM_COOKIE = () => {
  const token = Cookies.get("_token");

  if (token) {
    try {
      const decoded: TDecodedUser = jwtDecode(token);

      return {
        type: UserActions.SET_USER,
        payload: decoded,
      };
    } catch (err) {
      return {
        type: UserActions.SET_USER,
        payload: null,
      };
    }
  } else {
    return {
      type: UserActions.SET_USER,
      payload: null,
    };
  }
};

export const CHECK_AUTH = async () => {
  return await userModel.checkAuth();
};

export const EDIT_USER_INFO = async (data: TEditUserInfoBody) => {
  const { token } = await userModel.editUserInfo(data);

  const decoded = SET_USER_FROM_TOKEN(token);

  return {
    type: UserActions.SET_USER,
    payload: decoded.user,
  };
};

export const CHANGE_PASSWORD = async (data: TChangePasswordBody) => {
  const { token } = await userModel.changePassword(data);

  const decoded = SET_USER_FROM_TOKEN(token);

  return {
    type: UserActions.SET_USER,
    payload: decoded.user,
  };
};
